import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, CardHeader, CircularProgress, Typography } from '@mui/material';
import { useAdjustmentDetails } from '@hooks';
import { FullWidthContent, MainMenuLayout } from '@layouts';
import { GoBackButton } from '@molecules';
import styles from '../styles';

/**
 * Adjustment detail screen for internal users
 */
const ClientsAdjustmentScreen = () => {
  const navigate = useNavigate();
  const { adjustmentId } = useParams();
  const { t } = useTranslation();
  const { data, isLoading, error } = useAdjustmentDetails({ adjustmentId });

  /** format labels
   * @param key - The content of the label
   */
  const formatLabel = (key) => {
    const result = key.replace(/([a-z])([A-Z])/g, '$1_$2').toUpperCase();
    return result === 'FECHA_VALOR'
      ? t('CLIENTS:ADJUSTMENT:VALUE_DATE')
      : t(`CLIENTS:ADJUSTMENT:${result}`);
  };
  /**
   * shows the adjustment data
   */
  const renderContent = () => {
    if (error || !data) {
      return <Typography>{t('CLIENTS:ADJUSTMENT:MISSING_ADJUSTMENT')}</Typography>;
    }

    return (
      <Box sx={styles.contentContainer}>
        {Object.entries(data)
          .filter(([key]) => key !== '_id' && key !== '_class')
          .map(([key, value]) => {
            let displayValue = value;

            if (key === 'fechaValor' && typeof value === 'string') {
              const date = new Date(value);
              displayValue = !isNaN(date.getTime()) ? date.toLocaleDateString() : value;
            }

            return (
              <Box key={key} sx={styles.adjustmentBox}>
                <Typography variant='body2' fontWeight='bold' sx={styles.adjustmentLabel}>
                  {formatLabel(key)}:
                </Typography>
                <Typography variant='body2'>
                  {typeof displayValue === 'object' && displayValue !== null
                    ? JSON.stringify(displayValue)
                    : String(displayValue)}
                </Typography>
              </Box>
            );
          })}
      </Box>
    );
  };

  return (
    <MainMenuLayout>
      <FullWidthContent>
        {isLoading ? (
          <Box sx={styles.spinner}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <CardHeader title={t('CLIENTS:ADJUSTMENT:DETAIL_ADJUSTMENT_TITLE')} />
            {renderContent()}
          </>
        )}

        <GoBackButton variant='outlined' backFunction={() => navigate(-1)} />
      </FullWidthContent>
    </MainMenuLayout>
  );
};

export default ClientsAdjustmentScreen;
